export default "__VITE_ASSET__DkzEx_2h__";